import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { closeModal, animateModal, closeModalAnimation } from '../../../Modal/modal-actions/modal-actions';
import { InputText } from '../../../reusables/index.js';
import { reduxForm } from 'redux-form';
import messages from '../../../../i18n/base-en.js';
import OfferLandingPagesCard from '../OfferLandingPagesCard/OfferLandingPagesCard.react';
import { Gtm } from '../../../../utils/gtm';
import useClickOutside from '../../../reusables/colorpicker/useClickOutside';

import 'materialize-css';
import { Select } from 'react-materialize';

const OfferLandingPagesModal = ({
  dispatch,
  offerUrl,
  fields,
  offerScreenshots,
  availableDevices,
  viewMode,
  isReferrals,
  skinConfigurations,
  changeCurrentOffer,
  currentOfferUrl,
  isAutoOptimized,
  modalInner,
}) => {
  const [offersList, setOffersList] = useState(offerUrl);
  const [searchResult, setSearchResult] = useState();
  const [sortType, setSortType] = useState();
  const [modalViewMode, setModalViewMode] = useState(viewMode);
  const [checkedId, setCheckedId] = useState(currentOfferUrl.id ? currentOfferUrl.id : 'optimized');
  const [selectedLanding, setSelectedLanding] = useState('');
  const optimizedList = offersList.filter((offer) => offer.id === 'optimized');

  const sortTypeList = {
    newest: 'id',
    oldest: 'id',
    epc_highest: 'epc_affiliation',
    epc_lowest: 'epc_affiliation',
    name_asc: 'name',
    name_desc: 'name',
  };

  const epcHighSort = offerUrl.sort((a, b) => {
    if (a.epc_affiliation === b.epc_affiliation) {
      return 0;
    } else if (a.epc_affiliation === null) {
      return 1;
    } else if (b.epc_affiliation === null) {
      return -1;
    } else {
      return b.epc_affiliation > a.epc_affiliation ? 1 : -1;
    }
  });

  useEffect(() => {
    const sortProperty = sortTypeList[sortType];
    const sorted = [...offersList].sort((a, b) => {
      switch (sortType) {
        case 'name_asc':
          return b[sortProperty] ? a[sortProperty]?.replace(/\s/g, '').localeCompare(b[sortProperty].replace(/\s/g, '')) : -1;
        case 'newest':
        case 'epc_highest':
          if (Number(a[sortProperty]) === Number(b[sortProperty])) {
            return 0;
          } else if (Number(a[sortProperty]) === null) {
            return 1;
          } else if (Number(b[sortProperty]) === null) {
            return -1;
          } else {
            return Number(b[sortProperty]) > Number(a[sortProperty]) ? 1 : -1;
          }
        case 'oldest':
        case 'epc_lowest':
          if (Number(a[sortProperty]) === Number(b[sortProperty])) {
            return 0;
          } else if (Number(a[sortProperty]) === null) {
            return 1;
          } else if (Number(b[sortProperty]) === null) {
            return -1;
          } else {
            return Number(a[sortProperty]) > Number(b[sortProperty]) ? 1 : -1;
          }
        default:
          return a[sortProperty] ? b[sortProperty]?.replace(/\s/g, '').localeCompare(a[sortProperty].replace(/\s/g, '')) : 1;
      }
    });
    setOffersList(sorted);
  }, [sortType]);

  useEffect(() => {
    if (fields.searchString.value.length >= 3) {
      const filteredLandings = offerUrl.filter((landing) =>
        landing.name.toLocaleLowerCase().includes(fields.searchString.value.toLocaleLowerCase())
      );
      setOffersList(filteredLandings);
      setSearchResult(filteredLandings.length);
    } else {
      setSearchResult(isAutoOptimized ? offerUrl.length - 1 : offerUrl.length);
      setOffersList(epcHighSort);
    }
  }, [fields.searchString.value, offerUrl]);

  const handleViewModeChange = (device) => {
    setModalViewMode(device);
  };

  const handleSave = () => {
    Gtm.event('UI Component', 'Click', `available landing page - ${selectedLanding}`);
    changeCurrentOffer(checkedId);
    dispatch(animateModal());
    setTimeout(() => {
      dispatch(closeModal());
    }, 500);
  };

  const handleCheckId = (id) => {
    setCheckedId(id);
  };

  const handleSelectLanding = (name) => {
    setSelectedLanding(name);
  };

  const closeOpenModal = () => {
    dispatch(closeModalAnimation());
  };

  useClickOutside(modalInner, closeOpenModal);

  return (
    <div className="available-landing-modal" id="screenshot-modal">
      <div className="modal-content">
        <div className="modal-box">
          <div className="modal-header">
            <div className="sub-header">
              <h4 className="primary-color">
                <FormattedMessage {...messages.offerAvailableLandingPage} />
              </h4>
              <div className="preview-type mobile-preview">
                {offerScreenshots
                  ? availableDevices.map((device) => (
                      <span
                        className={`pointer device-icon ${device.name}-icon ${
                          modalViewMode === device.name ? 'primary-color' : ''
                        }`}
                        data-viewmode={device.name}
                        key={device.name}
                        onClick={() => handleViewModeChange(device.name)}
                      >
                        <i className="material-icons" data-cy={`preview-type-device-${device.name}`}>
                          {device.icon}
                        </i>
                      </span>
                    ))
                  : null}
              </div>
            </div>
            <div className="search-tool">
              <div className=" search-input" id="search-string">
                <InputText
                  field={fields.searchString}
                  id="search-input"
                  maxLength={40}
                  placeholder="Search..."
                  prefixIcon="&#xE8B6;"
                  tabIndex={10}
                  type="text"
                />
              </div>
              <div className="devices-icons">
                <div className="rightside-tools">
                  <div className="preview-type desktop-preview">
                    <FormattedMessage {...messages.genericTextPreviewType} />
                    {offerScreenshots
                      ? availableDevices.map((device) => (
                          <span
                            className={`pointer device-icon ${device.name}-icon ${
                              modalViewMode === device.name ? 'primary-color' : ''
                            }`}
                            key={device.name}
                            onClick={() => handleViewModeChange(device.name)}
                          >
                            <i className="material-icons" data-cy={`preview-type-device-${device.name}`}>
                              {device.icon}
                            </i>
                          </span>
                        ))
                      : null}
                  </div>
                  <div className="sort-by" data-cy="sort-by-dropdown">
                    <FormattedMessage {...messages.genericTextSortingLandingPage} />
                    <Select
                      className="input-field"
                      id="sorting"
                      name="sorting"
                      onChange={(e) => {
                        setSortType(e.target.value);
                        Gtm.event('UI Component', 'Click', 'Console-Landing-Sort');
                      }}
                    >
                      <option data-cy="option-epc_highest" value="epc_highest">
                        EPC : Highest
                      </option>
                      <option data-cy="option-epc_lowest" value="epc_lowest">
                        EPC : Lowest
                      </option>
                      <option data-cy="option-newest" value="newest">
                        Newest
                      </option>
                      <option data-cy="option-oldest" value="oldest">
                        Oldest
                      </option>
                      <option data-cy="option-name_asc" value="name_asc">
                        A-Z
                      </option>
                      <option data-cy="option-name_desc" value="name_desc">
                        Z-A
                      </option>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {optimizedList.length > 0 && <span className="desktop-results">Landing Optimizer</span>}
          {optimizedList.map((optimizedLanding) => (
            <OfferLandingPagesCard
              checked={optimizedLanding.id === checkedId}
              handleCheckId={handleCheckId}
              handleSelectLanding={handleSelectLanding}
              isAutoOptimized
              isReferrals={isReferrals}
              key={optimizedLanding.id}
              landingPage={optimizedLanding}
              skinConfigurations={skinConfigurations}
              viewMode={modalViewMode}
            />
          ))}
          <span className="desktop-results">{searchResult} results</span>
          {offersList.map(
            (landingPage) =>
              landingPage.id !== 'optimized' && (
                <OfferLandingPagesCard
                  checked={landingPage.id === checkedId}
                  handleCheckId={handleCheckId}
                  handleSelectLanding={handleSelectLanding}
                  isReferrals={isReferrals}
                  key={landingPage.id}
                  landingPage={landingPage}
                  skinConfigurations={skinConfigurations}
                  viewMode={modalViewMode}
                />
              )
          )}
        </div>
      </div>
      <div className="modal-footer">
        <button
          className="waves-effect btn-large btn-flat cancel-button primary-border-color"
          data-cy="landing-page-cancel"
          onClick={closeOpenModal}
        >
          <FormattedMessage {...messages.genericTextCancel} />
        </button>
        <button className="waves-effect waves-light btn" data-cy="landing-page-save" onClick={() => handleSave()}>
          save
        </button>
      </div>
    </div>
  );
};
export default reduxForm({
  form: 'OfferModalSearch',
  fields: ['searchString'],
})(OfferLandingPagesModal);
